<template>
  <contact-form-fieldset
    class="contact-form__meeting-type"
    :class-content-wrapper="classContentWrapper"
    :legend="texts.selectMeetingType"
    :required="true"
    :tooltip="meetingTypeTooltip"
  >
    <div
      class="radio-button contact-form-radio-button"
      v-for="(title, type) in meetingTypes"
      :key="type"
      :class="{
        'contact-form-radio-button--active': meetingTypeModel === type,
      }"
      @click="meetingTypeModel = type"
    >
      <input
        class="contact-form-radio-button__input"
        name="meetingType"
        type="radio"
        v-model="meetingTypeModel"
        :id="type"
        :value="type"
      />
      <label class="marker contact-form-radio-button__label" :for="type">
        <span v-text="title" />
        <span
          class="meeting-type-location"
          v-if="showLocationText(type)"
          v-html="locationText"
        />
      </label>
    </div>
  </contact-form-fieldset>
</template>

<script>
import { mapState } from 'vuex';
import { isTherapyRequest, MEETING_TYPE_KEYS } from '../constants';
import ContactFormFieldset from './ContactFormFieldset.vue';

export default {

  components: {
    ContactFormFieldset,
  },

  computed: {
    ...mapState('user', ['address']),

    classContentWrapper() {
      let className = 'contact-form__radio-buttons-horizontal';

      if (Object.keys(this.meetingTypes).length === 1) {
        className += ' single-choice';
      }

      if (Object.keys(this.meetingTypes).length === 4) {
        className += ' four-choices';
      }

      return className;
    },

    locationText() {
      if (!this.address) {
        return '';
      }

      const { address_1, city } = this.address;

      if (!address_1 || !city) {
        return '';
      }

      return `${address_1}, ${city}`;
    },

    meetingTypeModel: {
      get() {
        return this.meetingType;
      },
      set(value) {
        this.$emit('update:meetingType', value);
      },
    },

    meetingTypes() {
      return this.availableMeetingTypes
        ? this.availableMeetingTypes
        : {
            [MEETING_TYPE_KEYS.VIDEO]: theme_vars.contactTexts.videoMeeting,
            [MEETING_TYPE_KEYS.AT_OUR_OFFICES]:
              theme_vars.contactTexts.meetingOurOffice,
            [MEETING_TYPE_KEYS.OTHER]: theme_vars.contactTexts.doesNotMatter,
          };
    },

    meetingTypeTooltip() {
      return theme_vars?.tooltip[this.requestType]?.meetingType;
    },
  },

  data() {
    return {
      texts: theme_vars.contactTexts,
    };
  },

  methods: {
    showLocationText(type) {
      return (
        isTherapyRequest(this.requestType) &&
        type === MEETING_TYPE_KEYS.AT_OUR_OFFICES &&
        this.locationText
      );
    },
  },
  name: 'MeetingType',

  props: {
    availableMeetingTypes: {
      default: null,
      type: Object,
    },
    meetingType: {
      default: '',
      type: String,
    },
    requestType: {
      default: '',
      type: String,
    },
  },
};
</script>
